__turbopack_context__.v({
  "button": "Button-module-scss-module__HB5Z3q__button",
  "fade-in": "Button-module-scss-module__HB5Z3q__fade-in",
  "fullWidth": "Button-module-scss-module__HB5Z3q__fullWidth",
  "fullWidthLtMd": "Button-module-scss-module__HB5Z3q__fullWidthLtMd",
  "hoverGhost": "Button-module-scss-module__HB5Z3q__hoverGhost",
  "no-transform": "Button-module-scss-module__HB5Z3q__no-transform",
  "noWrap": "Button-module-scss-module__HB5Z3q__noWrap",
  "rotate": "Button-module-scss-module__HB5Z3q__rotate",
  "size--lg": "Button-module-scss-module__HB5Z3q__size--lg",
  "size--md": "Button-module-scss-module__HB5Z3q__size--md",
  "size--sm": "Button-module-scss-module__HB5Z3q__size--sm",
  "size--xl": "Button-module-scss-module__HB5Z3q__size--xl",
  "size--xs": "Button-module-scss-module__HB5Z3q__size--xs",
  "sizeLtMd--lg": "Button-module-scss-module__HB5Z3q__sizeLtMd--lg",
  "sizeLtMd--md": "Button-module-scss-module__HB5Z3q__sizeLtMd--md",
  "sizeLtMd--sm": "Button-module-scss-module__HB5Z3q__sizeLtMd--sm",
  "sizeLtMd--xl": "Button-module-scss-module__HB5Z3q__sizeLtMd--xl",
  "sizeLtMd--xs": "Button-module-scss-module__HB5Z3q__sizeLtMd--xs",
  "sizeMd--lg": "Button-module-scss-module__HB5Z3q__sizeMd--lg",
  "sizeMd--md": "Button-module-scss-module__HB5Z3q__sizeMd--md",
  "sizeMd--sm": "Button-module-scss-module__HB5Z3q__sizeMd--sm",
  "sizeMd--xl": "Button-module-scss-module__HB5Z3q__sizeMd--xl",
  "sizeMd--xs": "Button-module-scss-module__HB5Z3q__sizeMd--xs",
  "variantCritical": "Button-module-scss-module__HB5Z3q__variantCritical",
  "variantCta": "Button-module-scss-module__HB5Z3q__variantCta",
  "variantInverted": "Button-module-scss-module__HB5Z3q__variantInverted",
  "variantNoBg": "Button-module-scss-module__HB5Z3q__variantNoBg",
  "variantOutline": "Button-module-scss-module__HB5Z3q__variantOutline",
  "variantOutlineInverted": "Button-module-scss-module__HB5Z3q__variantOutlineInverted",
  "variantPrimary": "Button-module-scss-module__HB5Z3q__variantPrimary",
  "variantSecondary": "Button-module-scss-module__HB5Z3q__variantSecondary",
});
